import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux'
import { Breadcrumb, Button, Form, InputGroup } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { getRequest } from '../../helpers/apiHandler';
import config from '../../config/Constant';
import CustomAlert from '../../components/CustomAlert';
import plusIcon from '../../assets/SidebarIcons/icon-plus.svg'
import AdminAddEditModal from './AdminAddEditModal'
import AdminDeleteModal from './AdminDeleteModal';
import { sortByDate } from '../../helpers/helperFunction';

const AdminManagement = () => {
  const { access_token } = useSelector((state) => state.auth.user)
  const [loadingData, setLoadingData] = useState(false);
  const [data, setData] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [modalMode, setModalMode] = useState('add');
  const [selectedAdmin, setSelectedAdmin] = useState({});

  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const getAdmin = () => {
    setLoadingData(true);
    const header = { headers: { Authorization: access_token.token } };

    getRequest(`/admin/admin-overview`, header, (res) => {
      if (res.success) {
        const result = res.data;
        setData(result);
      } else {
        setAlertState({
          message: 'There was an issue while fetching admin data',
          show: true,
          variant: 'danger',
        });
      }
      setLoadingData(false);
    });
  };

  const columns = [
    {
      name: 'Name',
      sortable: true,
      selector: (row) => row.name,
    },
    {
      name: 'Email',
      sortable: true,
      selector: (row) => row.email,
    },
    {
      name: 'Created At',
      sortable: true,
      selector: (row) => row.created_at,
      sortFunction: sortByDate('created_at'),
    },
    {
      name: 'Role',
      selector: (row) => (
        row.role === 'admin' ? "Admin" : "Manager"
      ),
    },
    {
      name: 'Actions',
      minWidth: '250px',
      selector: (row) => (
        <div className="d-flex justify-content-center align-items-center gap-1">
          <Button
            variant="primary"
            onClick={() => openModal('edit', row)}
            style={{ minWidth: 100 }}
          >
            Edit
          </Button>
          <Button
            variant="danger"
            onClick={() => openDeleteModal(row)}
            style={{ minWidth: 100 }}
          >
            Delete
          </Button>
        </div>
      ),
    }
  ];

  const openModal = (mode, rowData) => {
    setModalMode(mode);
    setSelectedAdmin(rowData);
    setShowModal(true);
  };

  const openDeleteModal = (rowData) => {
    setSelectedAdmin(rowData);
    setShowDeleteModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setShowDeleteModal(false);
    setSelectedAdmin({});
  };

  useEffect(() => {
    getAdmin()
  }, []);

  const onSubmit = () => {
    closeModal()
  }

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <div className="w-100">
      <div className="page-heading admin-heading">
        <div className="container-left" style={{ marginBottom: "32px" }}>
          <div className="page-title">Admin Management</div>
        </div>
        <div className="cta-button-wrapper mt-0">
          <Button
            variant="primary"
            style={{ minWidth: 160 }}
            onClick={() => openModal('add', {})}
          >
            <img alt="..." src={plusIcon} />
            Add Admin
          </Button>
        </div>
      </div>
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <div>
        <DataTable
          columns={columns}
          data={data}
          progressPending={loadingData}
          paginationComponentOptions={{
            rowsPerPageText: 'Items per page:',
          }}
          pagination
        />
      </div>
      <AdminAddEditModal
        show={showModal}
        onClose={closeModal}
        mode={modalMode}
        onSubmit={onSubmit}
        data={selectedAdmin}
        setAlertState={setAlertState}
        refreshData={getAdmin}
      />
      <AdminDeleteModal
        show={showDeleteModal}
        onClose={closeModal}
        data={selectedAdmin}
        setAlertState={setAlertState}
        refreshData={getAdmin}
      />
    </div>
  );
};

export default AdminManagement;
